import * as React from "react";
import { useDrawerContext } from "./DrawerContext";
import "../../styles/component/layout/AskLegalLayout.scss";

export const AskLegalLayout = (props: {
    content: JSX.Element;
    header: JSX.Element;
    footer?: JSX.Element;
}) => {
    const { isDrawerOpen, drawerSize } = useDrawerContext();

    const effectiveWidth = isDrawerOpen
        ? window.innerWidth - drawerSize
        : window.innerWidth;

    const getResponsiveClasses = () => {
        if (!isDrawerOpen) return "";
        const classes = ["drawer-open"];
        if (effectiveWidth <= 500) {
            classes.push("effective-minimal");
        } else if (effectiveWidth <= 1024) {
            classes.push("effective-compressed");
        } else {
            classes.push("effective-full");
        }
        return classes.join(" ");
    };

    const containerStyle: React.CSSProperties = {
        transition: "margin-right 0.3s ease-in-out",
        marginRight: isDrawerOpen ? `${drawerSize}px` : "0px",
        width: "100%",
        "--drawer-size": isDrawerOpen ? `${drawerSize}px` : "0px",
        "--effective-width": `${effectiveWidth}px`
    } as React.CSSProperties;

    const containerClassName = `sherpa-main-ui ${getResponsiveClasses()}`;

    return (
        <div className={containerClassName} style={containerStyle}>
            { props.header }
            <div style={{ "zIndex" : "auto" }}>
                { props.content }
            </div>
            { !!props.footer && props.footer }
        </div>
    );
};

export namespace AskLegalLayoutUtils {
    export const scrollWithOffset = (el, offset) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = offset;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
    };
}
